import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AsyncPipe, CommonModule } from '@angular/common';
import { from, Observable } from 'rxjs';
import { UserContextProvider } from '../../../infrastructure/context/user-context-provider';
import { dateFormat } from '../../../utilities/DateUtility';
import { Reservation } from '../../../feature/reservations/models/Reservation';
import { PropertyHelper } from '../../../feature/properties/shared/PropertyHelper';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reservation-detail-card',
  templateUrl: './reservation-detail-card.component.html',
  styleUrls: ['./reservation-detail-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    AsyncPipe
  ]
})
export class ReservationDetailCardComponent {

  @Input() reservation?: Reservation;

  formattedPropertyAddress$?: Observable<string>;

  dateFormat = dateFormat;

  constructor(
    public userContextProvider: UserContextProvider,
    private readonly propertyHelper: PropertyHelper,
    private router: Router
  ) { }

  async ngOnInit(){
    this.formattedPropertyAddress$ = this.reservation ? from(this.propertyHelper.getFormattedPropertyAddress(this.reservation.property)) : undefined;
  }

  onGoToReservationClick() {
    this.router.navigate([`/reservations/detail/${ this.reservation?.reservation_id }`]);
  }

  onGoToPropertyClick() {
    this.router.navigate([`/properties/detail/${ this.reservation?.property.property_id }`]);
  }

  onGoToGuestClick() {
    this.router.navigate([`/guests/detail/${ this.reservation?.guests[0].guest_id }`]);
  }
}